import { network } from 'services/network';

export const createContract = (params) => {
    return network.post('api/bo/management/createContract', params).then((response) => {
        return response.data;
    });
};
